import { render } from "./cardX.vue?vue&type=template&id=57c7f34b&scoped=true"
import script from "./cardX.vue?vue&type=script&lang=js"
export * from "./cardX.vue?vue&type=script&lang=js"

import "./cardX.vue?vue&type=style&index=0&id=57c7f34b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c7f34b"]])

export default __exports__